<mat-form-field style="display: none">
  <input matInput [formControl]="control" />
</mat-form-field>
